import React from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { withNamespaces } from 'react-i18next'
import LanguageSwitcher from '../components/LanguageSwitcher'
import { setLanguage } from '../redux/actions/actions'

export const LanguageSwitcherContainer = props => {
	return <LanguageSwitcher {...props} />
}

const mapStateToProps = state => {
    return {
        initialValues: {
            lang: state.language.currentLang
        }
    }
}

const mapDispatchToProps = (dispatch, props) => {
	return {
		onChange: data => {
			const { i18n } = props
            i18n.changeLanguage(data.lang.value)
            dispatch(setLanguage(data.lang))
		}
	}
}

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'langForm', destroyOnUnmount: false })(LanguageSwitcherContainer)))



// WEBPACK FOOTER //
// ./src/containers/LanguageSwitcherContainer.js